import $ from 'jquery';
import Service from '../lib/ajax/Service';
import UrlHelper from '../lib/ajax/UrlHelper';
import { formButtonHandler } from '../../tnew/tnew';

class DeleteHandler {
  buildUrl(el) {
    const $el = $(el);
    const type = $el.attr('data-tn-delete-type');
    const id = $el.attr('data-tn-delete-id');
    const token = $el.attr('data-tn-delete-flex-session');

    return `/cart/details/remove${type}/${id}/${token}`;
  }

  removeItem() {
    const url = this.deleteUrl;

    new Service()
      .post(url, null)
      .done((validationPoint) => {
        if (validationPoint === '') {
          window.location.href = window.location.href;
          return;
        }

        const urlHelper = new UrlHelper();
        window.location.href = urlHelper.buildAbsolute(`components/precart/?p=${validationPoint}`);
      });
  }

  activate(el) {
    const $el = $(el);
    const url = this.buildUrl($el);

    this.deleteUrl = url;

    const isDeleteModalHidden = (localStorage.getItem('tn-is-delete-modal-hidden') === 'true');

    if (isDeleteModalHidden) {
      $el.addClass('tn-delete-busy');

      $el.prop('disabled', true);

      this.removeItem();
    } else {
      $('#tn-delete-modal').modal('show');
    }
  }

  modalConfirm() {
    const isHidden = $('.tn-do-not-show-again')[0].checked;

    localStorage.setItem('tn-is-delete-modal-hidden', isHidden);

    this.removeItem();
  }

  listen() {
    $(() => {
      const $buttons = $('[data-tn-delete-id]');

      if ($buttons.length) {
        $buttons.on('click', (event) => {
          this.activate(event.currentTarget);
        });

        $(document).on('click', '#tn-delete-button-submit', (event) => {
          formButtonHandler.applyBusyStyling(event.currentTarget);
          this.modalConfirm();
        });
      }
    });
  }

}

export default DeleteHandler;



// WEBPACK FOOTER //
// ./V7/tnew/handlers/DeleteHandler.js